import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetJourney } from '@/store/reset';

export interface TransactionState {
  transactionId: string,
  subscriptionId: string,
  complete: boolean,
  errorMessage?: string,
  successUrl?: string,
  failureUrl?: string,
  transSourceUrl?: string,
  showReCaptchaV2: boolean,
}

const initialState: Readonly<TransactionState> = {
  transactionId: '',
  subscriptionId: '',
  complete: false,
  showReCaptchaV2: false,
};

export const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setTransactionId(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        transactionId: action.payload,
      };
    },
    setSubscriptionId(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        subscriptionId: action.payload,
      };
    },
    setComplete(state: TransactionState, action: PayloadAction<boolean>) {
      return {
        ...state,
        complete: action.payload,
      };
    },
    setErrorMessage(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        errorMessage: action.payload,
      };
    },
    clearErrorMessage(state: TransactionState) {
      const newState = { ...state };
      delete newState.errorMessage;
      return newState;
    },
    setSuccessUrl(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        successUrl: action.payload,
      };
    },
    setFailureUrl(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        failureUrl: action.payload,
      };
    },
    setTransSourceUrl(state: TransactionState, action: PayloadAction<string>) {
      return {
        ...state,
        transSourceUrl: action.payload,
      };
    },
    setShowRecaptchaV2: (state: TransactionState, action: PayloadAction<boolean>) => ({
      ...state,
      showReCaptchaV2: action.payload,
    }),
  },
  extraReducers: builder => builder.addCase(resetJourney, () => initialState),
});

export const {
  setTransactionId,
  setSubscriptionId,
  setComplete,
  setErrorMessage,
  clearErrorMessage,
  setFailureUrl,
  setSuccessUrl,
  setTransSourceUrl,
  setShowRecaptchaV2,
} = transactionSlice.actions;
